/**
* @ngdoc component
* @name common.component:itxShopCartGiftTicket
* @description
* This component has 2 states based if user has selected or not the order as a gift.
* Shows a line in the shop cart page with the checkbox element, the correspondent label and the edit button if apply.
* @param {boolean} giftTicketSelected Gift ticket added to the shopcart
*/
(function() {
    'use strict';

    var itxShopCartGiftTicket = {
        bindings: {
            giftState:'<',
            onToggleGift:'&'
        },
        controller:   itxShopCartGiftTicketCtrl,
        templateUrl: 'shop-cart-gift-ticket.component.html'
    };

    itxShopCartGiftTicketCtrl.$inject = [];

    function itxShopCartGiftTicketCtrl (
    ) {
        var _this = this;

        _this.$onInit = function () {
            _this.setInput();
        };

        _this.$onChanges = function (changes) {
            if (!changes.giftState.isFirstChange()) {
                _this.setInput();
            }
        };

        _this.onToggleGiftInput = function(edit){
            _this.setInput();
            _this.onToggleGift({edit:edit});
        };

        _this.setInput = function () {
            _this.inputSelected = _this.giftState.giftSelected;
        };
    }

    angular.module('itxApp.common')
    .component('itxShopCartGiftTicket',itxShopCartGiftTicket);

})();